import React from "react";
import Dropdown  from "react-bootstrap/Dropdown";
import DropdownButton  from "react-bootstrap/DropdownButton";

function BasicButtonExample() {
  return (
    <DropdownButton id="dropdown-basic-button" title="Menu" style={{marginLeft: '25px'}}>
      <Dropdown.Item href="#home">Início</Dropdown.Item>
      <Dropdown.Item href="#services">Serviços</Dropdown.Item>
      <Dropdown.Item href="/about">Sobre Nós</Dropdown.Item>
      <Dropdown.Item href="#faq">Perguntas Frequentes</Dropdown.Item>
      <Dropdown.Item href="#testimonials">Depoimentos</Dropdown.Item>
      <Dropdown.Item href="#contact">Contatos</Dropdown.Item>
    </DropdownButton>
  );
}

export default BasicButtonExample;

